export default defineComponent({
  beforeCreate() {
    const { sync } = this.$options;

    if (!sync) {
      return;
    }

    if (!this.$options.computed) {
      this.$options.computed = {};
    }

    const attrs = this.$attrs.modelValue || this.$attrs.value || this.$attrs;
    const attrsKeys = Object.keys(attrs);

    for (const key of sync) {
      // Prepend '-' to each upper case letter, then cast to lower
      const hasKey = attrsKeys.includes(key);

      if (!hasKey) {
        if (!attrsKeys.includes(keyHyphenated)) {
          this.$log.warn(`Missing required sync-prop: "${key}"`, this);
          continue;
        }
      }

      this.$options.computed[key] = {
        get() {
          // Props in `attrs` have the same notation as their v-bind.
          // Since binds are in kebab-case and sync props in camelCase,
          // we need to ensure using the correct one to fully support
          // non-shorthand v-bind syntax
          return attrs[key];
        },
        set(val) {
          this.$emit(`update:${key}`, val);
        },
      };
    }
  },
});
